import { ActivityKindEnum } from '../../../types/enums';
import type { AdsFilteringType } from '../../../types/ads';

export const normalizeAdsFilteringObject = (filteringObj: AdsFilteringType): AdsFilteringType => {
  const normalizedFilteringObj: AdsFilteringType = { ...filteringObj };

  if (normalizedFilteringObj.activityKind === ActivityKindEnum.Rent) {
    normalizedFilteringObj.completionStatus = undefined;
  } else if (normalizedFilteringObj.activityKind === ActivityKindEnum.Sale) {
    normalizedFilteringObj.rentFrequency = undefined;
  } else {
    normalizedFilteringObj.completionStatus = undefined;
    normalizedFilteringObj.rentFrequency = undefined;
    normalizedFilteringObj.activityKind = undefined;
  }

  if (!normalizedFilteringObj.propertyKind?.length) {
    normalizedFilteringObj.propertyKind = undefined;
  }

  const creator = normalizedFilteringObj.creator;
  if (!creator?.kind && !creator?.id) {
    normalizedFilteringObj.creator = undefined;
    normalizedFilteringObj['creator.name'] = undefined;
    normalizedFilteringObj['creator.kind'] = undefined;
    normalizedFilteringObj['creator.id'] = undefined;
  } else {
    normalizedFilteringObj.creator = { ...creator };
    normalizedFilteringObj['creator.name'] = creator.name || undefined;
    normalizedFilteringObj['creator.kind'] = creator.kind || undefined;
    normalizedFilteringObj['creator.id'] = creator.id || undefined;
  }

  const handover = normalizedFilteringObj.handover;
  if (!handover?.quarter && !handover?.year) {
    normalizedFilteringObj.handover = undefined;
    normalizedFilteringObj['handover.quarter'] = undefined;
    normalizedFilteringObj['handover.year'] = undefined;
  } else {
    normalizedFilteringObj.handover = { ...handover };
    normalizedFilteringObj['handover.quarter'] = handover.quarter || undefined;
    normalizedFilteringObj['handover.year'] = handover.year || undefined;
  }

  return normalizedFilteringObj;
};
